export default __webpack_public_path__ + "static/media/ViteCapital_Logo_only_apple_icon.563faa10.png";